/**
 * The Chase row's note narrative (Ed, 2026-09-22): every note is a new,
 * timestamped entry — never edited — shown as bubbles, newest on the left.
 * Pure, no imports, Node-testable.
 */

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "22 Sep 14:05" in the viewer's local time; "" when unknown. Fixed month
 *  names, not toLocaleString, so every browser prints the same label. */
export function noteStamp(at: string | null | undefined): string {
  if (!at) return "";
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${hh}:${mm}`;
}

/** Who wrote it, short: the part of the email before "@". */
export function noteAuthor(email: string | null | undefined): string {
  return email ? email.split("@")[0] : "";
}
